module.exports = __webpack_public_path__ + "static/media/bookmark-white.c5df5bc7.svg";